
<tr class="hover" @click="openPreview">
  <td class="row-name d-flex align-items-center">
    <div class="custom-control custom-checkbox" @click.stop>
      <input type="checkbox" :checked="isSelected" class="custom-control-input mr-1" :id="'checkDoc_' + file.id"
        @change="toggleSelection" />
      <label class="custom-control-label" :for="'checkDoc_' + file.id"></label>
    </div>
    <b>{{ file.name }}</b>
  </td>
  <td>
    <span v-if="hasCases">{{ displayCaseNames }}</span>
    <span v-else><i>No assigned case</i></span>
  </td>
  <td style="width: 10%;">{{ prettyDate(file.created_at) }}</td>
</tr>
